<section class="dialog_container">
  <div class="title_container">
    @if (!data.isCompletion && data.revisionNumber > 0) {
      <span class="title_text"
        >Add Charging Details for Form #{{ data.formNumber }}, Revision
        {{ data.revisionNumber }}</span
      >
    }
    @if (!data.isCompletion && data.revisionNumber === 0) {
      <span class="title_text">Add Charging Details for Form #{{ data.formNumber }}</span>
    }
    @if (data.isCompletion && data.revisionNumber > 0) {
      <span class="title_text">Complete Form #{{ data.formNumber }}</span>
    }
    @if (data.isCompletion && data.revisionNumber === 0) {
      <span class="title_text"
        >Complete Form #{{ data.formNumber }}, Revision {{ data.revisionNumber }}</span
      >
    }
  </div>

  <section class="content_container">
    <div class="effective_date_picker">
      <span>Effective Date</span>
      <mat-form-field>
        <input
          matInput
          [matDatepicker]="effectiveDatePicker"
          [(ngModel)]="effectiveDate"
          style="color: #696969"
        />
        <mat-datepicker-toggle matSuffix [for]="effectiveDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #effectiveDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    @for (table of tables; track table; let tableIndex = $index) {
      <div class="table_container">
        @if (duplicates[tableIndex] && duplicates[tableIndex].length > 0) {
          <div class="duplicate_error">
            <img src="assets/error.svg" />
            <span [style.font-size]="'14px'">
              Column names must be unique. Please update any duplicate column names in order to
              proceed.
            </span>
          </div>
        }
        <input
          matInput
          class="table_name_input"
          placeholder="Table Name"
          [value]="tables[tableIndex].tableName"
          (blur)="onTableNameChange($event, tableIndex)"
        />
        <div class="table_wrapper">
          <span class="add_column_plus" (click)="addColumn(tableIndex)">+</span>
          <span class="add_row_plus" (click)="addRow(tableIndex)">+</span>
          <table
            mat-table
            [dataSource]="table.tableData"
            class="detail-table"
            [style.border]="
              duplicates[tableIndex] && duplicates[tableIndex].length > 0 ? '1px solid #740A16' : ''
            "
          >
            @for (column of getColumnDefs(tableIndex); track column; let columnIndex = $index) {
              <ng-container [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef>
                  <input
                    matInput
                    class="table_column_name_input"
                    [ngClass]="{ duplicate_column: isDuplicate(tableIndex, columnIndex) }"
                    [value]="table.columns[columnIndex].colName"
                    (blur)="onColumnNameChange($event, tableIndex, columnIndex)"
                  />
                </th>
                <td mat-cell *matCellDef="let element; let rowIndex = index">
                  <input
                    matInput
                    class="table_row_name_input"
                    [value]="getRowValue(tableIndex, rowIndex, columnIndex)"
                    (blur)="onRowValueChage($event, tableIndex, rowIndex, columnIndex)"
                  />
                </td>
              </ng-container>
            }
            <tr mat-header-row *matHeaderRowDef="getColumnDefs(tableIndex)"></tr>
            <tr mat-row *matRowDef="let row; columns: getColumnDefs(tableIndex)"></tr>
          </table>
        </div>
        @if (tableIndex === tables.length - 1) {
          <div class="add_table_button" (click)="addTable()">
            <span class="add_table_button_plus">+</span>
            <span class="add_table_button_text">Add Table</span>
          </div>
        }
      </div>
    }

    <div class="comments">
      <span>Comments (Optional)</span>
      <textarea [(ngModel)]="comments"></textarea>
    </div>
  </section>

  <div class="cta_container">
    <button mat-button (click)="onCancel()" class="button-secondary">CANCEL</button>
    @if (!data.isCompletion) {
      <button mat-button (click)="onSave()" class="button-primary" cdkFocusInitial type="submit">
        SAVE DETAILS
      </button>
    }
    @if (data.isCompletion) {
      <button mat-button (click)="onSave()" class="button-primary" cdkFocusInitial type="submit">
        COMPLETE
      </button>
    }
  </div>
</section>
